import { TableCard } from '../../../../components'
import { PegaPlantaoContent } from './components/content/PegaPlantaoContent'
import { PegaPlantaoHeader } from './components/header/PegaPlantaoHeader'
import { ListFiltersProvider } from './core/ListFiltersProvider'
import { QueryRequestProvider } from './core/QueryRequestProvider'
import { QueryResponseProvider } from './core/QueryResponseProvider'

const PegaPlantaoList = () => (
  <TableCard>
    <PegaPlantaoHeader />
    <div className='card-body pt-0 position-relative'>
      <PegaPlantaoContent />
    </div>
  </TableCard>
)

export const PegaPlantaoListWrapper = () => (
  <QueryRequestProvider>
    <QueryResponseProvider>
      <ListFiltersProvider>
        <PegaPlantaoList />
      </ListFiltersProvider>
    </QueryResponseProvider>
  </QueryRequestProvider>
)
